export const libVersion = 'local'; // processed by @rollup/plugin-replace
